module.exports = __webpack_public_path__ + "static/img/js5.324aea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/js5.png
// module id = TExX
// module chunks = 1